module.exports = __webpack_public_path__ + "img/28.82ec17a0.jpg";